<template>
	<div class="concept ma-4">
		<h4 class="my-5">{{ $t("document.header") }}</h4>
		<v-card
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.user_guide.path" target="_BLANK">
							{{ documents.user_guide.name_chi }}
						</a>
						<a v-else :href="documents.user_guide.path" target="_BLANK">
							{{ documents.user_guide.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.user_guide.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
			v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.incharge_manual.path" target="_BLANK">
							{{ documents.incharge_manual.name_chi }}
						</a>
						<a v-else :href="documents.incharge_manual.path" target="_BLANK">
							{{ documents.incharge_manual.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.incharge_manual.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.key_function_incharge.path" target="_BLANK">
							{{ documents.key_function_incharge.name_chi }}
						</a>
						<a v-else :href="documents.key_function_incharge.path" target="_BLANK">
							{{ documents.key_function_incharge.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.key_function_incharge.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.group_experiment_incharge.path" target="_BLANK">
							{{ documents.group_experiment_incharge.name_chi }}
						</a>
						<a v-else :href="documents.group_experiment_incharge.path" target="_BLANK">
							{{ documents.group_experiment_incharge.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.group_experiment_incharge.version }}
					</div>
				</div>
			</div>
		</v-card>
		<v-card
		v-if="$cookies.get('user_level')=='INCHARGE'||$cookies.get('user_level')=='ADMIN'"
			class="mx-auto mt-3"
			outlined>
			<div class="ma-4">
				<div class="d-flex align-center justify-space-between">
					<div class="d-flex align-center">
						<v-icon class="p-1" color="primary">mdi-file</v-icon>
						<a v-if="$i18n.locale=='tc'" :href="documents.campus_network_setup_preparation.path" target="_BLANK">
							{{ documents.campus_network_setup_preparation.name_chi }}
						</a>
						<a v-else :href="documents.campus_network_setup_preparation.path" target="_BLANK">
							{{ documents.campus_network_setup_preparation.name }}
						</a>
					</div>
					<div class="grey--text text--darken-1 text-caption">
						{{ $t("document.version") }}{{ documents.campus_network_setup_preparation.version }}
					</div>
				</div>
			</div>
		</v-card>
	</div>
</template>
<script>
	import moment from 'moment';
	export default {
		name: 'concept',
		components: {
		},
		data:function(){
			return{
				documents:{
					user_guide: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-User_Guide.pdf',
						name: 'User Guide - English',
						name_chi: '用戶指南 - 英文',
						version: '2026-02-03'
					},
					incharge_manual: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Incharge_Full_Manual.pdf',
						name: 'Full User Manual (Teacher) - English',
						name_chi: '完全用戶手冊（老師）— 英文版本',
						version: '2026-02-03'
					},
					key_function_incharge: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Key_Functions_of_Incharge.pdf',
						name: 'Key Functions Manual (Teacher) - English',
						name_chi: '常用功能手冊（老師）— 英文版本',
						version: '2026-02-03'
					},
					group_experiment_incharge: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Group_Experiment_Guideline_for_Teacher.pdf',
						name: 'Group Experiment Guideline (Teacher) - English',
						name_chi: '多人參與實驗指引（老師）— 英文版本',
						version: '2026-02-03'
					},
					campus_network_setup_preparation: {
						path: 'https://labxra.edu.hk/remotelab/files/documents/BL365-Campus_Network_Setup_Preparation_Guide.pdf',
						name: 'Campus Network Setup Preparation Guide - English',
						name_chi: '校園網絡設置準備指南 — 英文版本',
						version: '2025-11-17'
					}
				},
			}
		},
		mounted: function(){
			var self = this;
		},
		methods:{
		}
	}
</script>
